// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__ypnzj","info":"Note_info__1tnMN","note":"Note_note__9PUUw","actions":"Note_actions__2nTDo"};